import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]
  static values = {
    index: Number
  }

  connect() {
    // Set initial index based on existing fields
    this.indexValue = this.containerTarget.querySelectorAll('.nested-fields').length

    console.log('Current index:', this.indexValue)
  }

  add(event) {
    event.preventDefault()

    // Get template and replace index placeholder
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, this.indexValue)

    // Insert before the template (or append to container)
    this.containerTarget.insertAdjacentHTML('beforeend', content)

    this.indexValue++
  }

  remove(event) {
    event.preventDefault()
    console.log(event.target);
    const wrapper = event.target.closest('[data-nested-field-wrapper]')

    // If persisted record, mark for destruction
    const destroyInput = wrapper.querySelector('input[name*="_destroy"]')
    if (destroyInput) {
      destroyInput.value = '1'
      wrapper.style.display = 'none'
      this.deactivateInputs(wrapper)
    } else {
      // New record, just remove from DOM
      wrapper.remove()
    }

    // The removed record's fields no longer count towards the form being complete.
    this.element.dispatchEvent(new Event('change', { bubbles: true }))
  }

  // A hidden wrapper still holds live inputs. If one of them is `required` and empty, the browser refuses to
  // submit and tries to focus a field nobody can see, and the form validator keeps the submit
  // button disabled. Disabling them takes them out of both checks and out of the submitted
  // params. The hidden 'id' and '_destroy' fields stay enabled, so Rails still destroys the row.
  deactivateInputs(wrapper) {
    wrapper.querySelectorAll('input, select, textarea').forEach(input => {
      if (input.type === 'hidden') return

      input.disabled = true
      input.removeAttribute('required')
    })
  }
}